import { Expose, Type } from "class-transformer";

import { Building } from "./building.model";
import { PgaPolicy } from "./pga-policy.model";

export class HouseholdPolicy extends PgaPolicy {
    @Expose()
    @Type(() => Building)
    buildings: Building[] = [];
}
